/* eslint-disable import/first,import/order */
import React, {Component} from 'react';
import ModalBaseLayout from '../ModalBaseLayout';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {ActionModalHide} from '../../../store/actions/actions-modal';
import {ActionUploadPortfolioFile} from '../../../store/actions/actions-request';
import {CloseIcon} from '../../SvgComponents/SvgComponents';
import {NotificationError} from '../../../services/notifications';

class ModalUploadFile extends Component {
  constructor(props) {
    super(props);

    this.settings = ModalBaseLayout.getInitialSettings({
      className: 'modal-center loading-popup',
      closeButton: true,
      keyboard: true,
    });

    this.state = {
      file: null,
      fileName: '',
    };
  }

  onCancelClick = () => {
    this.props.ActionModalHide();
  };

  downloadFileChangeHandle = (e) => {
    const file = e.target.files[0];

    if (!file) return null;
    const fileSize = file.size || 0;
    const fileName = file.name.split('.')[0] || 'file';
    if (fileSize >= 50120998) {
      NotificationError('Размер файла должен быть не более 50 мб');
      return null;
    }

    this.setState({
      file,
      fileName,
    });
  };

  uploadFile = () => {
    const {file, fileName} = this.state;
    const {type} = this.props;
    const fileFormat = file.name.split('.')[1];
    const newFile = new File([file], `${fileName}.${fileFormat}`, {type: file.type});

    if (newFile) {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('type', type);

      this.props.ActionUploadPortfolioFile(formData, fileName || 'file');
    }
  };

  renderInputByType = () => {
    const {type} = this.props;

    if (type === 4) {
      return (
        <input
          accept="video/mp4,video/x-m4v,video/*"
          type="file"
          className="loading-file"
          id="select-file"
          onChange={this.downloadFileChangeHandle}
        />
      );
    }

    return (
      <input
        type="file"
        accept="image/*"
        className="loading-file"
        id="select-file"
        onChange={this.downloadFileChangeHandle}
      />
    );
  };

  onChangeFileName = (e) => {
    this.setState({
      fileName: e.target.value,
    });
  };

  getFileType = () => {
    const {type} = this.props;

    switch (type) {
    case 2:
      return 'изображение';
    case 3:
      return 'документ';
    case 4:
      return 'видеофайл';
    default:
      return 'файл';
    }
  };

  render() {
    const {file, fileName} = this.state;
    const {loading} = this.props;

    return (
      <ModalBaseLayout {...this.settings}>
        <div className="modal-container">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-header_title loading-title">
                Загрузить
                {this.getFileType()}
              </h3>
              <button
                className="modal-close-btn"
                onClick={this.onCancelClick}
              >
                <CloseIcon />
              </button>
            </div>
            <div className="loading-descr">
              Вы можете загрузить файл со своего компьютера
              {/* или вставить ссылки на YouTube */}
            </div>
            <div className="loading-form">
              <div className="loading-item-input loading-file-wrap">
                {this.renderInputByType()}
                <label htmlFor="select-file" className="loading-file-label">
                  {!file && 'Выбрать файл'}
                  {file && (
                    <>
                      Выбранный файл
                      <br />
                      {' '}
                      {file.name}
                    </>
                  )}
                </label>
              </div>
              {file && (
                <input
                  type="text"
                  className="ui-input loading-item"
                  value={fileName}
                  onChange={this.onChangeFileName}
                />
              )}
              <button
                className={`loading-item-input loading-button button button-dark-radius-sm button-full ${loading ? 'btn-loading' : ''}`}
                onClick={this.uploadFile}
                disabled={!file}
              >
                {loading ? 'Загрузка...' : `Загрузить ${this.getFileType()}`}
                {loading ? <span className="loading-circle" /> : null}
              </button>
            </div>
          </div>
        </div>
      </ModalBaseLayout>
    );
  }
}

ModalUploadFile.propTypes = {};

function mapStateToProps({rLoading}) {
  return {
    loading: rLoading.uploadPortfolioFileLoading,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    ActionModalHide,
    ActionUploadPortfolioFile,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalUploadFile);
